import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class CleanBottleTabs {
    constructor(){
        this.header = {
            el: document.querySelector('header'),
        };

        this.menu = {
            logo: document.getElementById('logo-inline'),
        }

        this.section = {
            tabs: document.querySelector('section.clean-tabs-specs'), 
            bottle: document.querySelector('section.bottle-specs'), 
        }

        this.footer = document.querySelector('footer');

        this.company = document.getElementById('company');
    }

    init(){
        // if(!Sniff.features.mobile){
            this.set();
            this.animation();
        // }
    }

    set = () => {
        // Set using GSAP
    }

    animation = () => {
        gsap.to(this.section.tabs.querySelector('.clean-tab img'), {
            delay: 2,
            y: window.innerHeight,
            rotate: 45,
            scrollTrigger: {
                trigger: this.section.tabs,
                start: 'center center',
                scrub: true,
                // markers: true,
            }
        })

        gsap.to(this.section.tabs.querySelector('.clean-tab img'), {
            autoAlpha: 0,
            scrollTrigger: {
                trigger: this.section.bottle,
                start: 'top center',
                scrub: true,
                // markers: true,
            }
        })
    }
}
